import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	Experiments,
	ExperimentsSymbol,
	PageFeatureConfigSymbol,
	SdkHandlersProvider,
} from '@wix/thunderbolt-symbols'
import { name, ReactionsStateApiSymbol } from '../symbols'
import { EffectTriggersSdkHandlers, IReactionsStateApi, TriggersAndReactionsPageConfig } from '../types'
import { getFullId } from '@wix/thunderbolt-commons'

export const effectsTriggersSdkProvider = withDependencies(
	[ReactionsStateApiSymbol, named(PageFeatureConfigSymbol, name), ExperimentsSymbol, BrowserWindowSymbol],
	(
		reactionsStateAPI: IReactionsStateApi,
		pageConfig: TriggersAndReactionsPageConfig,
		experiment: Experiments,
		browserWindow: BrowserWindow
	): SdkHandlersProvider<EffectTriggersSdkHandlers> => {
		const getIdByCompIdAndName = (compId: string, effectName: string) => {
			const _compId = getFullId(compId)
			return pageConfig.compEffectsToVariantId[_compId][effectName]
		}

		return {
			getSdkHandlers: () => ({
				[name]: {
					toggleEffects: (compId: string, effects) => {
						const element = browserWindow?.document.getElementById(compId)
						if (!element && !experiment['specs.thunderbolt.useClassNamePropInReactionsStateApi']) {
							return
						}
						effects.forEach((effect) => {
							reactionsStateAPI.toggleState(getIdByCompIdAndName(compId, effect), compId, element)
						})
					},

					removeAllEffects: (compId: string) => {
						const element = browserWindow?.document.getElementById(compId)
						if (!element && !experiment['specs.thunderbolt.useClassNamePropInReactionsStateApi']) {
							return
						}
						reactionsStateAPI.removeAllStates(compId, element)
					},
					applyEffects: (compId: string, effects) => {
						const element = browserWindow?.document.getElementById(compId)
						if (!element && !experiment['specs.thunderbolt.useClassNamePropInReactionsStateApi']) {
							return
						}
						effects.forEach((effect) => {
							reactionsStateAPI.addState(getIdByCompIdAndName(compId, effect), compId, element)
						})
					},
					removeEffects: (compId: string, effects) => {
						const element = browserWindow?.document.getElementById(compId)
						if (!element && !experiment['specs.thunderbolt.useClassNamePropInReactionsStateApi']) {
							return
						}
						effects.forEach((effect) => {
							reactionsStateAPI.removeState(getIdByCompIdAndName(compId, effect), compId, element)
						})
					},

					registerToActiveEffectsChange: (callback) => {
						reactionsStateAPI.registerToActiveEffectsChange((compId: string, variantIds: Array<string>) =>
							callback(
								compId,
								variantIds.map((variantId) => pageConfig.variantIdToEffect[variantId])
							)
						)
					},
				},
			}),
		}
	}
)
